import TakeInProcessDialog from './TakeInProcessDialog';

export default TakeInProcessDialog;
